import * as React from "react";
import Link from "../link";
import { Icon, IconType } from "../icon";

export default function CloseLink({
	to,
	closeHandler,
	className,
	disabled,
	onClick = () => {
		// ..
	},
}: any) {
	return (
		<Link
			onClick={onClick}
			disabled={disabled}
			className={className}
			to={{ pathname: to, state: { direction: null } }}
		>
			<button onClick={closeHandler}>
				<Icon type={IconType.X} />
			</button>
		</Link>
	);
}
